<div class="p-grid" style="margin: 15px;">
    <!-- TABLEAU BROUILLON -->
    <p-table #dt 
        [columns]="tableauCols" 
        [value]="liste" 
        [paginator]="true" [rows]="10" 
        [showCurrentPageReport]="true" styleClass="ui-table-customers" 
        currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes" 
        [rowsPerPageOptions]="[10,25,50]"
        [rowHover]="true"
    >
   
        <ng-template pTemplate="caption">
            <div style="text-align: left ; margin: 2.5px auto;">
                
                <div class="p-grid">
                    <div class="p-col">
                        <p-multiSelect [appendTo]="'body'"  [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" [(ngModel)]="complexiteSelected" defaultLabel="Complexités"></p-multiSelect>
                    </div>
                    <div class="p-col">
                        <p-multiSelect [appendTo]="'body'"  [style]="{'width':'100%'}" [options]="ciblageParContenu" [(ngModel)]="contenuSelected" defaultLabel="Contenus" ></p-multiSelect>
                    </div>
                    <div class="p-col">
                        <p-multiSelect [appendTo]="'body'"  [style]="{'width':'100%'}" [options]="ciblageOp" [(ngModel)]="opSelected" defaultLabel="Opérateurs" ></p-multiSelect>
                    </div>
                    <div class="p-col">
                        <p-button class="ui-fluid search" [iconPos]="'right'" style="width: 100%;" icon="pi pi-search" label="Filtrer" (click)="filtrerFiches()"></p-button>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of tableauCols"  [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ></p-sortIcon>
                </th>
                <th style="width: 150px;">Cibler la fiche</th>
            </tr>
            <tr>
                <th *ngFor="let col of tableauCols" [ngSwitch]="col.field">
                   
                    <input *ngSwitchCase="'num_point_accueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">

                    

                </th>

                <th></th>
            </tr>
        </ng-template>
    
        <ng-template pTemplate="body" let-fiche let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" style="text-align: center;" >
                   
                    <ng-template [ngIf]="col.field === 'id_complexite'">
                        <span>
                            {{ getComplexite(fiche[col.field]) }}
                        </span>
                    </ng-template>
                    <ng-template [ngIf]="col.field !== 'id_complexite'" > 
                        {{fiche[col.field]}}
                    </ng-template>
                </td>
                
                <td align="center"> <p-button   type="button"  icon="pi pi-star" [disabled]="" class="btn-info" (click)="ciblerFiche(fiche['id_moderation'])"></p-button> </td>
               
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
            </tr>
        </ng-template>
        
    </p-table>
    <!-- FIN TABLEAU BROUILLON -->
</div>